module.exports = __webpack_public_path__ + "static/media/excellence_1.a9a5a555.jpeg";